import {replace} from 'lodash-es'


export const parseInt = (val) => replace(val, /\D/g, '')
